/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type PreviewKartePlannerCommentTemplateInput = {
  body: string;
  label: string;
  selections: Array<string>;
};

export type PreviewKartePlannerCommentTemplateMutationVariables = Exact<{
  input: Types.PreviewKartePlannerCommentTemplateInput;
}>;


export type PreviewKartePlannerCommentTemplateMutation = { previewKartePlannerCommentTemplate: { maybeUserNames: Array<string> } };


export const PreviewKartePlannerCommentTemplateDocument = gql`
    mutation previewKartePlannerCommentTemplate($input: PreviewKartePlannerCommentTemplateInput!) {
  previewKartePlannerCommentTemplate(input: $input) {
    maybeUserNames
  }
}
    `;

/**
 * __usePreviewKartePlannerCommentTemplateMutation__
 *
 * To run a mutation, you first call `usePreviewKartePlannerCommentTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePreviewKartePlannerCommentTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePreviewKartePlannerCommentTemplateMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function usePreviewKartePlannerCommentTemplateMutation(options: VueApolloComposable.UseMutationOptions<PreviewKartePlannerCommentTemplateMutation, PreviewKartePlannerCommentTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PreviewKartePlannerCommentTemplateMutation, PreviewKartePlannerCommentTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PreviewKartePlannerCommentTemplateMutation, PreviewKartePlannerCommentTemplateMutationVariables>(PreviewKartePlannerCommentTemplateDocument, options);
}
export type PreviewKartePlannerCommentTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PreviewKartePlannerCommentTemplateMutation, PreviewKartePlannerCommentTemplateMutationVariables>;